<template>
    <div class="apprentice-simple-card">
        <div class="top-text">
            {{ $t('profile_choice.choose_here_a_profile_and_related_courses') }}
        </div>

        <b-form-group
            :label="$t('profile_choice.profile')"
            label-for="role">
            <design-2021-apprentice-multiselect-component
                id="school-account-add-user-type"
                v-model="selectedProfile"
                label="name"
                :options="profilesIn"
                :show-labels="false"
                :multiple-select="false"></design-2021-apprentice-multiselect-component>
        </b-form-group>

        <b-form-group
            class="group-input-title"
            v-if="firstChoiceOptions.length || firstChoiceSelected"
            :label="$t('profile_choice.one_mandatory_profile_choice_course')"
            label-for="module-title-input">
            <design-2021-apprentice-multiselect-component
                v-model="firstChoiceSelected"
                label="name"
                :multiple-select="false"
                :options="firstChoiceOptions">
            </design-2021-apprentice-multiselect-component>
        </b-form-group>

        <b-form-group
            class="group-input-title"
            v-if="
                secondChoiceOptions.length ||
                firstChoiceSelected ||
                (selectedProfile && selectedProfile.name === 'Techniek')
            "
            :label="$t('profile_choice.one_mandatory_course_free_section')"
            label-for="module-title-input">
            <design-2021-apprentice-multiselect-component
                v-model="secondChoiceSelected"
                label="name"
                :multiple-select="false"
                :options="secondChoiceOptions">
            </design-2021-apprentice-multiselect-component>
        </b-form-group>

        <b-form-group
            class="group-input-title"
            v-if="secondChoiceSelected"
            :label="$t('profile.choose_one_or_two_more_courses')"
            label-for="module-title-input">
            <design-2021-apprentice-multiselect-component
                v-model="thirdChoiceSelected"
                label="name"
                :options="thirdChoiceOptions">
            </design-2021-apprentice-multiselect-component>
        </b-form-group>

        <div>
            <b-button
                type="submit"
                variant="primary"
                @click="save">
                {{ $t('common.save') }}
            </b-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'profile-choice-component',
    props: ['profileChoiceSurveyUserIn', 'coursesIn', 'profilesIn'],
    data() {
        return {
            selectedProfile: null,
            firstChoiceSelected: null,
            secondChoiceSelected: null,
            thirdChoiceSelected: [],
            profiles: [
                {
                    name: this.$t('profile_choice.care_and_welfare'),
                    firstChoiceOptions: [
                        this.$t('profile_choice.geography'),
                        this.$t('profile_choice.history'),
                        this.$t('profile_choice.maths'),
                    ],
                    secondChoiceOptions: [
                        this.$t('profile_choice.textiles'),
                        this.$t('profile_choice.drawing'),
                        this.$t('profile_choice.crafts'),
                        this.$t('profile_choice.woodworking'),
                    ],
                    thirdChoiceOptions: [
                        this.$t('profile_choice.french'),
                        this.$t('profile_choice.german'),
                        this.$t('profile_choice.maths'),
                        this.$t('profile_choice.physics_and_chemistry'),
                        this.$t('profile_choice.history'),
                        this.$t('profile_choice.geography'),
                    ],
                },
                {
                    name: this.$t('profile_choice.economics'),
                    firstChoiceOptions: [
                        this.$t('profile_choice.french'),
                        this.$t('profile_choice.german'),
                        this.$t('profile_choice.maths'),
                    ],
                    secondChoiceOptions: ['Textiel', 'Tekenen', 'Handvaardigheid', 'Houtbewerken'],
                    thirdChoiceOptions: [
                        this.$t('profile_choice.french'),
                        this.$t('profile_choice.german'),
                        this.$t('profile_choice.maths'),
                        this.$t('profile_choice.biology'),
                        this.$t('profile_choice.physics_and_chemistry'),
                        this.$t('profile_choice.history'),
                        this.$t('profile_choice.geography'),
                    ],
                },
                {
                    name: this.$t('profile_choice.technology'),
                    firstChoiceOptions: [],
                    secondChoiceOptions: [
                        this.$t('profile_choice.textiles'),
                        this.$t('profile_choice.drawing_course'),
                        this.$t('profile_choice.crafts'),
                        this.$t('profile_choice.woodworking'),
                    ],
                    thirdChoiceOptions: [
                        this.$t('profile_choice.french'),
                        this.$t('profile_choice.german'),
                        this.$t('profile_choice.biology'),
                        this.$t('profile_choice.economics'),
                    ],
                },
                {
                    name: this.$t('profile_choice.agriculture_green'),
                    firstChoiceOptions: [
                        this.$t('profile_choice.biology'),
                        this.$t('profile_choice.physics_and_chemistry'),
                    ],
                    secondChoiceOptions: [
                        this.$t('profile_choice.textiles'),
                        this.$t('profile_choice.drawing_course'),
                        this.$t('profile_choice.crafts'),
                        this.$t('profile_choice.woodworking'),
                    ],
                    thirdChoiceOptions: [
                        this.$t('profile_choice.french'),
                        this.$t('profile_choice.german'),
                        this.$t('profile_choice.economics'),
                        this.$t('profile_choice.biology'),
                        this.$t('profile_choice.physics_and_chemistry'),
                        this.$t('profile_choice.history'),
                    ],
                },
            ],
        };
    },
    computed: {
        firstChoiceOptions() {
            if (!this.selectedProfile) {
                return [];
            }

            for (const profile of this.profiles) {
                if (this.selectedProfile.name === profile.name) {
                    return this.coursesIn.filter((course) => {
                        return profile.firstChoiceOptions.find((c) => c === course.name);
                    });
                }
            }
        },
        secondChoiceOptions() {
            if (
                !this.selectedProfile ||
                (!this.firstChoiceSelected && this.selectedProfile.name !== this.$t('profile_choice.technology'))
            ) {
                return [];
            }

            for (const profile of this.profiles) {
                if (this.selectedProfile.name === profile.name) {
                    return this.coursesIn.filter((course) => {
                        return profile.secondChoiceOptions.find((c) => c === course.name);
                    });
                }
            }
        },
        thirdChoiceOptions() {
            if (!this.secondChoiceSelected) {
                return [];
            }

            for (const profile of this.profiles) {
                if (this.selectedProfile.name === profile.name) {
                    return this.coursesIn
                        .filter((course) => {
                            return profile.thirdChoiceOptions.find((c) => c === course.name);
                        })
                        .filter((course) => {
                            if (!this.firstChoiceSelected) {
                                return true;
                            }
                            return this.firstChoiceSelected.name !== course.name;
                        });
                }
            }
        },
    },
    methods: {
        save() {
            if (!this.thirdChoiceSelected.length || this.thirdChoiceSelected.length > 2) {
                this.alert.warning(this.$t('profile_choice.not_everything_filled_in_correctly'));
                return;
            }

            this.alert.saving();

            let courses = [
                { course_id: this.secondChoiceSelected.id, choice: 2 },
                ...this.thirdChoiceSelected.map((item) => {
                    return {
                        course_id: item.id,
                        choice: 3,
                    };
                }),
            ];

            if (this.firstChoiceSelected) {
                courses.push({ course_id: this.firstChoiceSelected.id, choice: 1 });
            }

            const data = {
                profile_id: this.selectedProfile.id,
                courses: courses,
            };

            this.axios.post(this.routes.profileChoiceCreate(this.profileChoiceSurveyUserIn.id), data).then(
                (response) => {
                    window.location.href = this.routes.baseUrl();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
    watch: {
        selectedProfile: function () {
            this.firstChoiceSelected = null;
            this.secondChoiceSelected = null;
            this.thirdChoiceSelected = [];
        },
        firstChoiceSelected: function () {
            this.secondChoiceSelected = null;
            this.thirdChoiceSelected = [];
        },
        secondChoiceSelected: function () {
            this.thirdChoiceSelected = [];
        },
    },
};
</script>

<style scoped>
.top-text {
    margin-bottom: 20px;
}
</style>
